import { Checkbox } from '@dgshahr/ui-kit'
import RadioButton from '@dgshahr/ui-kit/Form/RadioButton'
import { IGetCategoryResponseType } from '@/api/category/type'

interface ICategoriesProps {
  type: 'radio' | 'checkbox'
  name?: string
  categories: IGetCategoryResponseType[]
  selectedCategories: number[] | number | null
  onCategoriesChange: (selectedIds: number[] | number) => void
}

const Categories = ({
  type,
  name = 'category',
  selectedCategories,
  onCategoriesChange,
  categories
}: Readonly<ICategoriesProps>) => {
  const handleCategoryChange = (categoryId: number) => {
    if (type === 'radio') {
      onCategoriesChange(categoryId)
      return
    }

    const selectedIds = Array.isArray(selectedCategories)
      ? selectedCategories
      : []

    const newSelected = selectedIds.includes(categoryId)
      ? selectedIds.filter((id) => id !== categoryId)
      : [...selectedIds, categoryId]

    onCategoriesChange(newSelected)
  }

  if (!categories.length) {
    return (
      <div className="flex min-h-32 items-center justify-center">
        <span className="font-p3-regular text-gray-500">
          دسته‌بندی‌ای وجود ندارد!
        </span>
      </div>
    )
  }

  return (
    <div
      className="
        grid
        grid-cols-1
        gap-3
        desktop:grid-cols-2
      "
    >
      {categories.map((category) => {
        const isSelected =
          type === 'radio'
            ? selectedCategories === category.id
            : Array.isArray(selectedCategories) &&
              selectedCategories.includes(category.id)

        if (type === 'radio') {
          return (
            <RadioButton
              key={category.id}
              name={name}
              value={category.id}
              label={category.fa_name}
              variant="bordered"
              checked={isSelected}
              onChange={() => handleCategoryChange(category.id)}
            />
          )
        }

        return (
          <Checkbox
            key={category.id}
            label={category.fa_name}
            checked={isSelected}
            onChange={() => handleCategoryChange(category.id)}
          />
        )
      })}
    </div>
  )
}

export default Categories